<template>
  <div class="parution-wrap pt-20 pb-20">
    <div class="container mx-auto px-6 max-w-5xl text-gray-800 leading-relaxed">

      <!-- Titre principal -->
      <h2 class="text-3xl font-bold text-center mb-8 text-yellow-700 uppercase">
        Dernière Parution
      </h2>

      <!-- Description principale -->
      <p class="mb-4 text-lg">
        <strong>Culture, Foi et Raison</strong> est une revue internationale pour :
      </p>

      <ul class="list-disc list-inside mb-6">
        <li>
          Penser, à partir de la foi, les réalités culturelles et historiques africaines
          à partir d’une raison droite ;
        </li>
        <li>
          Proposer un dialogue rationnel et une analyse critique dans la société et dans l’Église
          (<em>Africæ munus, 137</em>) ;
        </li>
        <li>
          Participer à l’avènement de l’heure de l’Afrique.
        </li>
      </ul>

      <!-- Tarifs -->
      <h3 class="text-xl font-semibold mb-4 text-yellow-700">Tarifs d’abonnement</h3>
      <ul class="list-disc list-inside mb-6">
        <li>Un numéro : 3 500 FCFA</li>
        <li>Abonnement ordinaire : 6 000 FCFA</li>
        <li>Soutien : 10 000 FCFA</li>
        <li>Afrique de l’Ouest : 15 000 FCFA</li>
      </ul>

      <p class="italic mb-8 text-center">
        Fiches d’abonnement disponibles en ligne.
      </p>

      <!-- Images de la revue -->
      <div class="grid md:grid-cols-2 gap-8 text-center mb-10">
        <div>
          <h4 class="font-semibold text-lg mb-2">Face de la revue</h4>
          <!-- <img
            src="@/assets/images/face-revue.jpg"
            alt="Face de la revue"
            class="rounded-lg shadow-md mx-auto"
          /> -->
        </div>

        <div>
          <h4 class="font-semibold text-lg mb-2">Sommaire de la revue</h4>
          <!-- <img
            src="@/assets/images/sommaire-revue.jpg"
            alt="Sommaire de la revue"
            class="rounded-lg shadow-md mx-auto"
          /> -->
        </div>
      </div>

      <hr class="my-10 border-gray-300" />

      <!-- Notre revue -->
      <div>
        <h3 class="text-xl font-semibold mb-4 text-yellow-700">Notre revue</h3>
        <p class="mb-6">
          <strong>Présentation :</strong><br />
          La mission de l’EITP est de former des chrétiens qui fassent de la théologie à partir des défis de la foi.
          La théologie est enseignée avec ses implications dans la vie de foi.
          Il ne s’agit pas d’une incubation théologique, mais d’une théologie enracinée dans la vie.
        </p>

        <h4 class="font-semibold text-lg mb-2">Contacts et Adresse</h4>
        <p>
          <strong>École d’Initiation Théologique et Pastorale (EITP)</strong><br />
          Paroisse Saint Michel de Cotonou<br />
          <strong>Tél / WhatsApp :</strong> +229 60 60 17 17 / 61 39 47 47<br />
          <strong>Mail :</strong> eitp@yahoo.com / eitpcotonou@gmail.com<br />
          <strong>Site Web :</strong> www.eitp-cotonou.org<br />
          <strong>Heures d’ouverture :</strong> du lundi au vendredi, de 8 h à 17 h.
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ParutionPage",
  setup() {
    return {};
  },
});
</script>

<style scoped>
.parution-wrap {
  background-color: #fdfcfb;
}

ul {
  margin-left: 1rem;
}
</style>
